/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Region } from './Region';
import {
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
    RegionToJSONTyped,
} from './Region';

/**
 * Structure to create an anonymous person
 * @export
 * @interface AnonymousPersonCreateReq
 */
export interface AnonymousPersonCreateReq {
    /**
     * 
     * @type {Region}
     * @memberof AnonymousPersonCreateReq
     */
    region?: Region;
}



/**
 * Check if a given object implements the AnonymousPersonCreateReq interface.
 */
export function instanceOfAnonymousPersonCreateReq(value: object): value is AnonymousPersonCreateReq {
    return true;
}

export function AnonymousPersonCreateReqFromJSON(json: any): AnonymousPersonCreateReq {
    return AnonymousPersonCreateReqFromJSONTyped(json, false);
}

export function AnonymousPersonCreateReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnonymousPersonCreateReq {
    if (json == null) {
        return json;
    }
    return {
        
        'region': json['region'] == null ? undefined : RegionFromJSON(json['region']),
    };
}

export function AnonymousPersonCreateReqToJSON(json: any): AnonymousPersonCreateReq {
    return AnonymousPersonCreateReqToJSONTyped(json, false);
}

export function AnonymousPersonCreateReqToJSONTyped(value?: AnonymousPersonCreateReq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'region': RegionToJSON(value['region']),
    };
}

